<div class="amount-range">
  <div class="amount-range__title">{{title}}</div>
  <div class="amount-range__start">
    <app-filter-input
      [filter]="filterSumFrom">
    </app-filter-input>
  </div>
  <div class="amount-range__end">
    <app-filter-input
      [filter]="filterSumTo">
    </app-filter-input>
  </div>
</div>
